var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom-control custom-radio" }, [
    _c("input", {
      staticClass: "custom-control-input",
      attrs: { name: "radio", id: "customRadio" + _vm.value, type: "radio" },
      domProps: { checked: _vm.modelValue == _vm.value },
      on: { change: _vm.updateInput }
    }),
    _vm._v(" "),
    _vm.isRecommanded ? _c("em", [_vm._v("Cure recommandée")]) : _vm._e(),
    _vm._v(" "),
    _c(
      "label",
      {
        staticClass: "custom-control-label",
        attrs: { for: "customRadio" + _vm.value }
      },
      [
        _c("div", { staticClass: "descPrice" }, [
          _c("strong", [_vm._v(_vm._s(_vm.name))]),
          _vm._v(" "),
          _vm.numberOfDays > 1 && _vm.numberOfDays !== null
            ? _c("small", [_vm._v("(" + _vm._s(_vm.numberOfDays) + " jours)")])
            : _vm.numberOfDays <= 1 && _vm.numberOfDays !== null
              ? _c("small", [_vm._v("(" + _vm._s(_vm.numberOfDays) + " jour)")])
              : _c("small", [_vm._v(" ")]),
          _vm._v(" "),
          _c("span", { staticClass: "ref" }, [
            _vm._v("Réf. " + _vm._s(_vm.referenceCode) + " | ")
          ]),
          _vm._v(" "),
          !_vm.isUnavailable
            ? _c("span", { staticClass: "stock" }, [_vm._v("En stock")])
            : _vm._e(),
          _vm._v(" "),
          _vm.isUnavailable
            ? _c("span", { staticClass: "out-of-stock" }, [
                _vm._v("Bientôt disponible")
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "price" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm._f("moneyFormat")(_vm.price)) +
              "\n            "
          ),
          _vm.basePrice != _vm.price
            ? _c("span", { staticClass: "promo" }, [
                _c("del", [
                  _vm._v(_vm._s(_vm._f("moneyFormat")(_vm.basePrice)))
                ]),
                _vm._v(" " + _vm._s(_vm.advantageName) + "\n            ")
              ])
            : _vm._e()
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6acc1412", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6acc1412","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/SiteBundle/Resources/assets/components/CartReferenceCard.vue
// module id = 510
// module chunks = 1